import { ExperienceData } from './types'

export const experienceData: ExperienceData[] = [
    {
        title: 'Software Engineer',
        company: 'Amazon',
        location: 'Toronto, ON',
        dates: 'Jun 2026 — Present',
        description:
            'Accelerating and enhancing the capabilities of the Amazon Ads programmatic ad reporting platforms.',
    },
    {
        title: 'Software Engineer Intern',
        company: 'Deep Genomics',
        location: 'Toronto, ON',
        dates: 'Jan 2026 — Jun 2026',
        description:
            'Developing internal data tooling and infrastructure for scientists and ML researchers to accelerate genome research and analysis.',
    },
    {
        title: 'Software Developer Co-op',
        company: 'theScore',
        location: 'Toronto, ON',
        dates: 'May 2024 — Aug 2025',
        description:
            'Building software for the Retail Web team across PENN Entertainment retail properties and improving performance, observability, and developer experience across front-end applications for the Platform Web team.',
    },
    {
        title: 'Software Engineer',
        company: 'UofT Mechanical & Industrial Engineering',
        location: 'Toronto, ON',
        dates: 'Jan 2024 — Apr 2024',
        description:
            'Designed and developed a platform for managing and executing advanced pandemic simulations for morLab, led by Professor Dionne Aleman.',
    },
    // {
    //     title: 'Senior Project Developer',
    //     company: 'UofT Blueprint',
    //     location: 'Toronto, ON',
    //     dates: 'Sep 2023 — Apr 2024',
    //     description:
    //         'Spearheaded the development of a full-stack web and mobile application for the Center For Dreams, a non-profit focusing on educational and social integration programs for individuals with developmental disabilities.',
    // },
    {
        title: 'Software Engineer Intern',
        company: 'NerveX Neurotechnologies',
        location: 'Toronto, ON',
        dates: 'May 2023 — Jan 2024',
        description:
            'Enhanced API efficiency, developed a medical charting library, and streamlined data pipelines across digital telemedicine platforms.',
    },
]
